export const messages = {
  en: {
    payFeeOrder: {
      orderCharge: 'Order Charge',
      back: 'Back',
      feeId: 'Fee ID:',
      feeName: 'Fee Name:',
      feeType: 'Fee Type:',
      billingPeriod: 'Billing Period:',
      area: 'Area:',
      unitPrice: 'Unit Price:',
      additionalFee: 'Additional Fee:',
      fixedFee: 'Fixed Fee:',
      ownerAccount: 'Owner Account:',
      giftPoints: 'Gift Points:',
      amountReceivable: 'Amount Receivable:',
      advancePayment: 'Advance Payment:',
      prePay: 'Pre Pay',
      chargeTime: 'Charge Time:',
      requiredChargeTime: 'Required, please fill in the charge time',
      paymentMethod: 'Payment Method:',
      requiredPaymentMethod: 'Required, please select payment method',
      actualAmount: 'Actual Amount:',
      actualAmountPlaceholder: 'Please enter the actual amount received',
      attachment: 'Attachment:',
      remark: 'Remark:',
      remarkPlaceholder: 'Optional, please fill in the remark',
      scanCharge: 'Scan Charge',
      submitCharge: 'Submit Charge',
      roomDetails: 'Room Details',
      feeDetails: 'Fee Details',
      feeConfigDetails: 'Fee Configuration Details',
      uploadAttachment: 'Upload Attachment',
      prePayment: 'Pre Payment',
      refresh: 'Refresh',
      select: 'Select',
      remainingAmount: 'Remaining Amount',
      prePayTime: 'Pre Pay Time',
      depositInfo: 'Deposit Information',
      chargingObject: 'Charging Object',
      feeItem: 'Fee Item',
      timePeriod: 'Time Period',
      amount: 'Amount',
      chargingTime: 'Charging Time',
      operation: 'Operation',
      refundDeposit: 'Refund Deposit',
      way: 'Way',
      cash: 'Cash',
      toPrePay: 'To Pre Pay',
      refundReason: 'Refund Reason',
      refundReasonRequired: 'Refund reason cannot be empty',
      cancel: 'Cancel',
      submit: 'Submit',
      
    },
    viewRoomData: {
      details: 'Details',
      label: 'Item',
      value: 'Value',
      room: 'Room',
      floor: 'Floor',
      owner: 'Owner',
      phone: 'Phone',
      type: 'Type',
      builtUpArea: 'Built-up Area',
      roomArea: 'Room Area',
      rent: 'Rent',
      state: 'State',
      moveInTime: 'Move-in Time'
    },
    viewFeeData: {
      details: 'Details',
      label: 'Item',
      value: 'Value',
      feeId: 'Fee ID',
      feeFlag: 'Fee Flag',
      feeType: 'Fee Type',
      payerObj: 'Payer Object',
      feeName: 'Fee Name',
      state: 'State',
      createTime: 'Create Time',
      billingStartTime: 'Billing Start Time',
      billingEndTime: 'Billing End Time',
      batch: 'Batch'
    },
    viewFeeConfigData: {
      feeItem: 'Fee Item',
      label: 'Item',
      value: 'Value',
      configId: 'Config ID',
      feeType: 'Fee Type',
      feeName: 'Fee Name',
      feeFlag: 'Fee Flag',
      billType: 'Bill Type',
      paymentType: 'Payment Type',
      prepay: 'Prepay',
      postpay: 'Postpay',
      paymentCycle: 'Payment Cycle',
      billingStartTime: 'Billing Start Time',
      billingEndTime: 'Billing End Time',
      formula: 'Formula',
      unitPrice: 'Unit Price',
      additionalFee: 'Additional/Fixed Fee'
    },
    payFeeUserAccount: {
      title: 'Account Information',
      accountInfo: 'Account Information',
      refresh: 'Refresh',
      select: 'Select',
      accountType: 'Account Type',
      accountName: 'Account Name',
      accountAmount: 'Account Amount',
      operation: 'Operation',
      yuan: 'yuan',
      prestore: 'Prestore'
    },
    payFeeOrderResult: {
      title: 'Payment Prompt',
      success: 'Payment successful',
      receiptTip: 'Please go to the business acceptance page to reprint the receipt',
      back: 'Back',
      printSmall: 'Print Small Ticket',
      mergePrint: 'Merge Print',
      printReceipt: 'Print Receipt'
    },
  
    payFeeDiscount: {
      title: 'Discount Information',
      discountInfo: 'Discount Information',
      discountType: 'Discount Type',
      discountName: 'Discount Name',
      ruleName: 'Rule Name',
      rule: 'Rule',
      discountAmount: 'Discount Amount',
      discountTooltip: 'Negative: discounted amount; Positive: additional late fee',
      yuan: 'yuan',
      discount: 'Discount',
      penalty: 'Penalty',
      specialDiscount: 'Special Discount',
      monthSpec: 'Month',
      penaltySpec: 'Penalty'
    },
    payFeeCoupon: {
      title: 'Gift Coupon',
      couponInfo: 'Gift Coupon Information',
      ruleName: 'Rule Name',
      couponName: 'Coupon Name',
      quantity: 'Quantity',
      unit: 'pcs',
      purpose: 'Purpose'
    },
    prestoreAccount2: {
      title: 'Prestore',
      receivable: 'Receivable:',
      actualReceipt: 'Actual Receipt:',
      prestoreAmount: 'Prestore Amount:',
      amountPlaceholder: 'Required, please fill in the prestore amount',
      remark: 'Remark:',
      remarkPlaceholder: 'Optional, please fill in the remark',
      cancel: 'Cancel',
      save: 'Save',
      amountRequired: 'Amount cannot be empty',
      amountFormat: 'Amount format error',
      remarkMaxLength: 'Remark cannot exceed 200 characters',
      saveSuccess: 'Prestore successfully',
      saveError: 'Prestore failed'
    },
    prePayFeeDialog: {
      prePayment: 'Pre Payment',
      select: 'Select',
      feeName: 'Fee Name',
      monthlyUnitPrice: 'Monthly Unit Price',
      explanation: 'Explanation',
      receivableAmount: 'Receivable Amount',
      months: 'Months',
      selectMonths: 'Select Months',
      startingMonth: 'Starting Month',
      cancel: 'Cancel',
      confirm: 'Confirm'
    },
    payFeeOrderConfirm: {
      chargeConfirm: 'Charge Confirm',
      payeeObject: 'Payee Object:',
      amountReceivable: 'Amount Receivable:',
      actualAmount: 'Actual Amount:',
      transferAmount: 'Transfer Amount:',
      discountAmount: 'Discount Amount:',
      transferFee: 'Transfer Fee',
      requiredTransferFee: 'Required, please select transfer fee',
      pointsDeduction: 'Points Deduction:',
      accountDeduction: 'Account Deduction:',
      remark: 'Remark:',
      scanPay: 'Please use WeChat/Alipay to scan the QR code to complete payment',
      generatingQrCode: 'Generating payment QR code...',
      scanCodePlaceholder: 'Please scan the code with the code scanner',
      authCode: 'Auth Code:',
      authCodePlaceholder: 'Please scan with scanner',
      close: 'Close',
      confirmCharge: 'Confirm Charge'
    },
    orderPrePayFee: {
      prePayment: 'Pre Payment',
      refresh: 'Refresh',
      select: 'Select',
      feeName: 'Fee Name',
      remainingAmount: 'Remaining Amount',
      prePayTime: 'Pre Pay Time'
    },
  },
  zh: {
    payFeeOrder: {
      orderCharge: '订单收费',
      back: '返回',
      feeId: '费用ID:',
      feeName: '费用项:',
      feeType: '费用类型:',
      billingPeriod: '计费时间段:',
      area: '面积:',
      unitPrice: '单价:',
      additionalFee: '附加费:',
      fixedFee: '固定费:',
      ownerAccount: '业主账户:',
      giftPoints: '赠送积分:',
      amountReceivable: '应收款:',
      advancePayment: '预付款:',
      prePay: '预付',
      chargeTime: '缴费时间:',
      requiredChargeTime: '必填，请填写缴费时间',
      paymentMethod: '支付方式:',
      requiredPaymentMethod: '必填，请选择支付方式',
      actualAmount: '实收款:',
      actualAmountPlaceholder: '请输入实际收款金额',
      attachment: '附件:',
      remark: '备注:',
      remarkPlaceholder: '可填，请填写备注',
      scanCharge: '扫码收费',
      submitCharge: '提交收费',
      roomDetails: '房屋详情',
      feeDetails: '费用详情',
      feeConfigDetails: '费用项详情',
      uploadAttachment: '上传附件',
      prePayment: '预付款',
      refresh: '刷新',
      select: '选择',
      remainingAmount: '剩余金额',
      prePayTime: '预付时间',
      depositInfo: '押金信息',
      chargingObject: '收费对象',
      feeItem: '费用项',
      timePeriod: '时间段',
      amount: '金额',
      chargingTime: '缴费时间',
      operation: '操作',
      refundDeposit: '退押金',
      way: '方式',
      cash: '现金',
      toPrePay: '退到预付收款',
      refundReason: '退费原因',
      refundReasonRequired: '退费原因不能为空',
      cancel: '取消',
      submit: '提交',
      monthlyUnitPrice: '月单价',
      explanation: '说明',
      receivableAmount: '应收金额',
      months: '个月',
      selectMonths: '选择月份',
      startingMonth: '起始月',
      confirm: '确定',
      chargePrompt: '缴费提示',
      chargeSuccess: '缴费成功',
      receiptTip: '请到业务受理页面补打收据',
      
      printSmallTicket: '打印小票',
      mergedPrint: '合并打印',
      printReceipt: '打印收据',
      chargeConfirm: '收费确认',
      payeeObject: '付费对象：',
      transferAmount: '转存金额：',
      discountAmount: '优惠金额：',
      transferFee: '转存费用',
      requiredTransferFee: '必填，请选择转存费用',
      pointsDeduction: '积分抵扣：',
      accountDeduction: '账户抵扣：',
      scanPay: '请使用微信/支付宝扫描二维码完成支付',
      generatingQrCode: '正在生成支付二维码...',
      scanCodePlaceholder: '请用扫码枪扫码',
      close: '关闭',
      confirmCharge: '确定收费',
      discountInfo: '折扣信息',
      discountType: '折扣类型',
      discount: '优惠',
      lateFee: '违约',
      discountSpecial: '优惠(需要申请)',
      discountName: '折扣名称',
      ruleName: '规则名称',
      rule: '规则',
      yuan: '元',
      giftCoupons: '赠送优惠券',
      giftRule: '赠送规则',
      couponName: '优惠券名称',
      quantity: '数量',
      purpose: '用途',
      prestore: '预存',
      receivable: '应收',
      actual: '实收',
      prestoreAmount: '预存金额',
      requiredPrestoreAmount: '必填，请填写预存金额',
      optionalRemark: '可填，请填写备注',
      save: '保存'
    },
    viewRoomData: {
      details: '详情',
      label: '项目',
      value: '值',
      room: '房屋',
      floor: '楼层',
      owner: '业主',
      phone: '电话',
      type: '类型',
      builtUpArea: '建筑面积',
      roomArea: '室内面积',
      rent: '租金',
      state: '房屋状态',
      moveInTime: '入住时间'
    },
    viewFeeData: {
      details: '详情',
      label: '项目',
      value: '值',
      feeId: '费用ID',
      feeFlag: '费用标识',
      feeType: '费用类型',
      payerObj: '付费对象',
      feeName: '费用项',
      state: '费用状态',
      createTime: '建账时间',
      billingStartTime: '计费开始时间',
      billingEndTime: '计费结束时间',
      batch: '批次'
    },
    viewFeeConfigData: {
      feeItem: '费用项',
      label: '项目',
      value: '值',
      configId: '费用项ID',
      feeType: '费用类型',
      feeName: '收费项目',
      feeFlag: '费用标识',
      billType: '催缴类型',
      paymentType: '付费类型',
      prepay: '预付费',
      postpay: '后付费',
      paymentCycle: '缴费周期',
      billingStartTime: '计费起始时间',
      billingEndTime: '计费终止时间',
      formula: '公式',
      unitPrice: '计费单价',
      additionalFee: '附加/固定费用'
    },
    payFeeUserAccount: {
      title: '账户信息',
      accountInfo: '账户信息',
      refresh: '刷新',
      select: '选择',
      accountType: '账户类型',
      accountName: '账户名',
      accountAmount: '账户金额',
      operation: '操作',
      yuan: '元',
      prestore: '预存'
    },
    payFeeOrderResult: {
      title: '缴费提示',
      success: '缴费成功',
      receiptTip: '请到业务受理页面补打收据',
      back: '返回',
      printSmall: '打印小票',
      mergePrint: '合并打印',
      printReceipt: '打印收据'
    },
    payFeeOrderConfirm: {
      chargeConfirm: '收费确认',
      payeeObject: '付费对象:',
      amountReceivable: '应收金额:',
      actualAmount: '实收金额:',
      transferAmount: '转存金额:',
      discountAmount: '优惠金额:',
      transferFee: '转存费用',
      requiredTransferFee: '必填，请选择转存费用',
      pointsDeduction: '积分抵扣:',
      accountDeduction: '账户抵扣:',
      remark: '备注:',
      scanPay: '请使用微信/支付宝扫描二维码完成支付',
      generatingQrCode: '正在生成支付二维码...',
      scanCodePlaceholder: '请用扫码枪扫码',
      authCode: '授权码：',
      authCodePlaceholder: '请用扫码枪扫码',
      close: '关闭',
      confirmCharge: '确定收费'
    },
    payFeeDiscount: {
      title: '折扣信息',
      discountInfo: '折扣信息',
      discountType: '折扣类型',
      discountName: '折扣名称',
      ruleName: '规则名称',
      rule: '规则',
      discountAmount: '折扣金额',
      discountTooltip: '负数：打折减免的金额；正数：需额外缴纳的滞纳金',
      yuan: '元',
      discount: '优惠',
      penalty: '违约',
      specialDiscount: '优惠(需要申请)',
      monthSpec: '月份',
      penaltySpec: '滞纳金'
    },
    payFeeCoupon: {
      title: '赠送优惠券',
      couponInfo: '赠送优惠券',
      ruleName: '赠送规则',
      couponName: '优惠券名称',
      quantity: '数量',
      unit: '张',
      purpose: '用途'
    },
    prestoreAccount2: {
      title: '预存',
      receivable: '应收：',
      actualReceipt: '实收：',
      prestoreAmount: '预存金额：',
      amountPlaceholder: '必填，请填写预存金额',
      remark: '备注：',
      remarkPlaceholder: '可填，请填写备注',
      cancel: '取消',
      save: '保存',
      amountRequired: '金额不能为空',
      amountFormat: '金额格式错误',
      remarkMaxLength: '备注长度不能超过200位',
      saveSuccess: '预存成功',
      saveError: '预存失败'
    },
    prePayFeeDialog: {
      prePayment: '预付款',
      select: '选择',
      feeName: '费用名称',
      monthlyUnitPrice: '月单价',
      explanation: '说明',
      receivableAmount: '应收金额',
      months: '个月',
      selectMonths: '选择月份',
      startingMonth: '起始月',
      cancel: '取消',
      confirm: '确定'
    },
    orderPrePayFee: {
      prePayment: '预付款',
      refresh: '刷新',
      select: '选择',
feeName: '费用名称',
      remainingAmount: '剩余金额',
      prePayTime: '预付时间'
    },
  },
  'zh-TW': {
    payFeeOrder: {
      orderCharge: '訂單收費',
      back: '返回',
      feeId: '費用ID:',
      feeName: '費用項:',
      feeType: '費用類型:',
      billingPeriod: '計費時間段:',
      area: '面積:',
      unitPrice: '單價:',
      additionalFee: '附加費:',
      fixedFee: '固定費:',
      ownerAccount: '業主帳戶:',
      giftPoints: '贈送積分:',
      amountReceivable: '應收款:',
      advancePayment: '預付款:',
      prePay: '預付',
      chargeTime: '繳費時間:',
      requiredChargeTime: '必填，請填寫繳費時間',
      paymentMethod: '支付方式:',
      requiredPaymentMethod: '必填，請選擇支付方式',
      actualAmount: '實收款:',
      actualAmountPlaceholder: '請輸入實際收款金額',
      attachment: '附件:',
      remark: '備註:',
      remarkPlaceholder: '可填，請填寫備註',
      scanCharge: '掃碼收費',
      submitCharge: '提交收費',
      roomDetails: '房屋詳情',
      feeDetails: '費用詳情',
      feeConfigDetails: '費用項詳情',
      uploadAttachment: '上傳附件',
      prePayment: '預付款',
      refresh: '刷新',
      select: '選擇',
      remainingAmount: '剩餘金額',
      prePayTime: '預付時間',
      depositInfo: '押金資訊',
      chargingObject: '收費對象',
      feeItem: '費用項',
      timePeriod: '時間段',
      amount: '金額',
      chargingTime: '繳費時間',
      operation: '操作',
      refundDeposit: '退押金',
      way: '方式',
      cash: '現金',
      toPrePay: '退到預付收款',
      refundReason: '退費原因',
      refundReasonRequired: '退費原因不能為空',
      cancel: '取消',
      submit: '提交',
      monthlyUnitPrice: '月單價',
      explanation: '說明',
      receivableAmount: '應收金額',
      months: '個月',
      selectMonths: '選擇月份',
      startingMonth: '起始月',
      confirm: '確定',
      chargePrompt: '繳費提示',
      chargeSuccess: '繳費成功',
      receiptTip: '請到業務受理頁面補打收據',
      printSmallTicket: '列印小票',
      mergedPrint: '合併列印',
      printReceipt: '列印收據',
      chargeConfirm: '收費確認',
      payeeObject: '付費對象：',
      transferAmount: '轉存金額：',
      discountAmount: '優惠金額：',
      transferFee: '轉存費用',
      requiredTransferFee: '必填，請選擇轉存費用',
      pointsDeduction: '積分抵扣：',
      accountDeduction: '帳戶抵扣：',
      scanPay: '請使用微信/支付寶掃描二維碼完成支付',
      generatingQrCode: '正在生成支付二維碼...',
      scanCodePlaceholder: '請用掃碼槍掃碼',
      close: '關閉',
      confirmCharge: '確定收費',
      discountInfo: '折扣資訊',
      discountType: '折扣類型',
      discount: '優惠',
      lateFee: '違約',
      discountSpecial: '優惠(需要申請)',
      discountName: '折扣名稱',
      ruleName: '規則名稱',
      rule: '規則',
      yuan: '元',
      giftCoupons: '贈送優惠券',
      giftRule: '贈送規則',
      couponName: '優惠券名稱',
      quantity: '數量',
      purpose: '用途',
      prestore: '預存',
      receivable: '應收',
      actual: '實收',
      prestoreAmount: '預存金額',
      requiredPrestoreAmount: '必填，請填寫預存金額',
      optionalRemark: '可填，請填寫備註',
      save: '儲存'
    },
    viewRoomData: {
      details: '詳情',
      label: '項目',
      value: '值',
      room: '房屋',
      floor: '樓層',
      owner: '業主',
      phone: '電話',
      type: '類型',
      builtUpArea: '建築面積',
      roomArea: '室內面積',
      rent: '租金',
      state: '房屋狀態',
      moveInTime: '入住時間'
    },
    viewFeeData: {
      details: '詳情',
      label: '項目',
      value: '值',
      feeId: '費用ID',
      feeFlag: '費用標識',
      feeType: '費用類型',
      payerObj: '付費對象',
      feeName: '費用項',
      state: '費用狀態',
      createTime: '建帳時間',
      billingStartTime: '計費開始時間',
      billingEndTime: '計費結束時間',
      batch: '批次'
    },
    viewFeeConfigData: {
      feeItem: '費用項',
      label: '項目',
      value: '值',
      configId: '費用項ID',
      feeType: '費用類型',
      feeName: '收費項目',
      feeFlag: '費用標識',
      billType: '催繳類型',
      paymentType: '付費類型',
      prepay: '預付費',
      postpay: '後付費',
      paymentCycle: '繳費週期',
      billingStartTime: '計費起始時間',
      billingEndTime: '計費終止時間',
      formula: '公式',
      unitPrice: '計費單價',
      additionalFee: '附加/固定費用'
    },
    payFeeUserAccount: {
      title: '帳戶資訊',
      accountInfo: '帳戶資訊',
      refresh: '刷新',
      select: '選擇',
      accountType: '帳戶類型',
      accountName: '帳戶名',
      accountAmount: '帳戶金額',
      operation: '操作',
      yuan: '元',
      prestore: '預存'
    },
    payFeeOrderResult: {
      title: '繳費提示',
      success: '繳費成功',
      receiptTip: '請到業務受理頁面補打收據',
      back: '返回',
      printSmall: '列印小票',
      mergePrint: '合併列印',
      printReceipt: '列印收據'
    },
    payFeeOrderConfirm: {
      chargeConfirm: '收費確認',
      payeeObject: '付費對象:',
      amountReceivable: '應收金額:',
      actualAmount: '實收金額:',
      transferAmount: '轉存金額:',
      discountAmount: '優惠金額:',
      transferFee: '轉存費用',
      requiredTransferFee: '必填，請選擇轉存費用',
      pointsDeduction: '積分抵扣:',
      accountDeduction: '帳戶抵扣:',
      remark: '備註:',
      scanPay: '請使用微信/支付寶掃描二維碼完成支付',
      generatingQrCode: '正在生成支付二維碼...',
      scanCodePlaceholder: '請用掃碼槍掃碼',
      authCode: '授權碼：',
      authCodePlaceholder: '請用掃碼槍掃碼',
      close: '關閉',
      confirmCharge: '確定收費'
    },
    payFeeDiscount: {
      title: '折扣資訊',
      discountInfo: '折扣資訊',
      discountType: '折扣類型',
      discountName: '折扣名稱',
      ruleName: '規則名稱',
      rule: '規則',
      discountAmount: '折扣金額',
      discountTooltip: '負數：打折減免的金額；正數：需額外繳納的滯納金',
      yuan: '元',
      discount: '優惠',
      penalty: '違約',
      specialDiscount: '優惠(需要申請)',
      monthSpec: '月份',
      penaltySpec: '滯納金'
    },
    payFeeCoupon: {
      title: '贈送優惠券',
      couponInfo: '贈送優惠券',
      ruleName: '贈送規則',
      couponName: '優惠券名稱',
      quantity: '數量',
      unit: '張',
      purpose: '用途'
    },
    prestoreAccount2: {
      title: '預存',
      receivable: '應收：',
      actualReceipt: '實收：',
      prestoreAmount: '預存金額：',
      amountPlaceholder: '必填，請填寫預存金額',
      remark: '備註：',
      remarkPlaceholder: '可填，請填寫備註',
      cancel: '取消',
      save: '儲存',
      amountRequired: '金額不能為空',
      amountFormat: '金額格式錯誤',
      remarkMaxLength: '備註長度不能超過200位',
      saveSuccess: '預存成功',
      saveError: '預存失敗'
    },
    prePayFeeDialog: {
      prePayment: '預付款',
      select: '選擇',
      feeName: '費用名稱',
      monthlyUnitPrice: '月單價',
      explanation: '說明',
      receivableAmount: '應收金額',
      months: '個月',
      selectMonths: '選擇月份',
      startingMonth: '起始月',
      cancel: '取消',
      confirm: '確定'
    },
    orderPrePayFee: {
      prePayment: '預付款',
      refresh: '刷新',
      select: '選擇',
      feeName: '費用名稱',
      remainingAmount: '剩餘金額',
      prePayTime: '預付時間'
    },
  }
}